var map = {
	"./angel_death.mp3": 105,
	"./battle.mp3": 57,
	"./battle_start.mp3": 58,
	"./bite.mp3": 106,
	"./cat.mp3": 107,
	"./cat_death.mp3": 108,
	"./chains.mp3": 59,
	"./dog_death.mp3": 109,
	"./door.mp3": 60,
	"./draw.mp3": 61,
	"./dungeondoor.mp3": 62,
	"./female_death.mp3": 110,
	"./ghost.mp3": 63,
	"./kratos.mp3": 64,
	"./male_death.mp3": 111,
	"./miss.mp3": 65,
	"./monster_death.mp3": 66,
	"./potion.mp3": 67,
	"./punch.mp3": 112,
	"./roar0.mp3": 113,
	"./roar1.mp3": 114,
	"./roar2.mp3": 115,
	"./roar3.mp3": 116,
	"./scroll.mp3": 68,
	"./sheath.mp3": 117,
	"./spell.mp3": 118,
	"./sword.mp3": 119,
	"./victory.mp3": 69,
	"./victorymusic.mp3": 70,
	"./wait.mp3": 71,
	"./water.mp3": 120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 121;